import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "FeedManagement",
  data() {
    return {
      feeds: [],
      form: {
        name: "",
        url: "",
        script: "",
        api_short_id: "",
        prompt_short_id: "",
        image_ids: "",
        creator_id: "",
        organisation: "",
        section: "",
        author: "",
        additional: "",
        active: true
      },
      isEditing: false,
      editingId: null,
      deleteDialog: false,
      feedToDelete: null,
      showForm: false
    };
  },
  async created() {
    await this.fetchFeeds();
  },
  methods: {
    async toggleForm() {
      this.showForm = !this.showForm;
      //await this.resetForm();
    },
    async fetchFeeds() {
      try {
        const headers = getTokenHeader();
        const params = { principal_id: this.currentPrincipal };
        const res = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/feeds`,
          { params, headers }
        );
        this.feeds = res.data;
      } catch (err) {
        console.error("Failed to fetch feeds:", err);
      }
    },
    async addFeed() {
      try {
        const headers = getTokenHeader();
        const payload = {
          ...this.form,
          principal_id: this.currentPrincipal
        };
        await axios.post(
          `${env.prompts_api_client_url}api/eo-prompt/feed`,
          payload,
          { headers }
        );
        await this.resetForm();
        await this.fetchFeeds();
      } catch (err) {
        console.error("Failed to add feed:", err);
      }
    },
    async editFeed(feed) {
      const { principal_id, _id, ...rest } = feed;
      this.form = { ...rest };
      this.editingId = feed._id;
      this.isEditing = true;
      this.showForm = true;
    },
    async updateFeed() {
      try {
        const headers = getTokenHeader();
        const payload = {
          ...this.form,
          principal_id: this.currentPrincipal
        };
        await axios.put(
          `${env.prompts_api_client_url}api/eo-prompt/feed/${this.editingId}`,
          payload,
          { headers }
        );
        await this.resetForm();
        await this.fetchFeeds();
      } catch (err) {
        console.error("Failed to update feed:", err);
      }
    },
    async resetForm() {
      this.form = {
        name: "",
        url: "",
        api_short_id: "",
        prompt_short_id: "",
        image_ids: "",
        creator_id: "",
        organisation: "",
        section: "",
        script: "",
        author: "",
        additional: "",
        active: true
      };
      this.editingId = null;
      this.isEditing = false;
      this.showForm = false;
    },
    async confirmDelete(feed) {
      this.feedToDelete = feed;
      this.deleteDialog = true;
    },
    async deleteFeed() {
      try {
        const headers = getTokenHeader();
        await axios.delete(
          `${env.prompts_api_client_url}api/eo-prompt/feed/${this.feedToDelete._id}`,
          { headers }
        );
        this.deleteDialog = false;
        this.feedToDelete = null;
        await this.fetchFeeds();
      } catch (err) {
        console.error("Failed to delete feed:", err);
      }
    }
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    }
  },
  watch: {
    currentPrincipal() {
      this.fetchFeeds();
    }
  }
};
